/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-16T19:11:22.067
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveRentHouseBig,
	getRentHouseBigCreateInit,
	getRentHouseBigEditInit,
	getRentHouseBigView,
	deleteRentHouseBig,
	getFindRoomView
} from '@api/rentmanage/RentHouseBig';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getRentHouseBigCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseBigCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseBigEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseBigEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentHouseBig({}, RentHouseBig) {
			return new Promise((resolve, reject) => {
				saveRentHouseBig(RentHouseBig)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getRentHouseBigView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseBigView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getFindRoomView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFindRoomView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteRentHouseBig({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseBig({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
